module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-342.6b2af45.woff2";